import React from "react";
import { Container } from "reactstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { Col, Row, Space } from "antd";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowLeft01Icon,
  Briefcase06Icon,
  HajiIcon,
  PieChartIcon,
  UserRemove02Icon,
} from "@hugeicons/core-free-icons/index";
import { Link } from "react-router";

const PilgrimReports = () => {
  const { t } = useTranslation();

  const reports = [
    {
      key: "not-coming",
      icon: UserRemove02Icon,
      title: t("NOT_ARRIVED_PILGRIMS_REPORT"),
      to: "not-coming",
    },
    {
      key: "not-accommodated",
      icon: UserRemove02Icon,
      title: t("ACCOMMODATED_PILGRIMS_REPORT"),
      to: "not-accommodated",
    },
    {
      key: "campaign-group-pilgrims",
      icon: HajiIcon,
      title: t("PILGRIM_REPORTS"),
      to: "campaign-group-pilgrims",
    },
    {
      key: "pilgrim-nationality-stats",
      icon: PieChartIcon,
      title: t("PILGRIM_NATIONALITY_STATS_REPORT_TITLE"),
      to: "pilgrim-nationality-stats",
    },
    {
      key: "pilgrim-mission-stats",
      icon: Briefcase06Icon,
      title: t("PILGRIM_MISSION_STATS_REPORT_TITLE"),
      to: "pilgrim-mission-stats",
    },
  ];

  return (
    <div>
      <PageHeader title={t("PILGRIM_REPORTS")} sticky={false} />
      <Container fluid>
        <Row justify="start" gutter={[16, 16]}>
          {reports.map((report) => (
            <Col md={12} span={24} key={report.key}>
              <ReportCard key={report.key} {...report} />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default PilgrimReports;

const ReportCard = (props) => {
  const { icon, title, to } = props;

  return (
    <Link
      to={to}
      className="rounded-4 border border-1 p-4 w-100 justify-content-between d-flex align-items-center"
    >
      <Space>
        <HugeiconsIcon className="d-flex" icon={icon} />
        <p className="m-0 fw-bold">{title}</p>
      </Space>

      <HugeiconsIcon icon={ArrowLeft01Icon} />
    </Link>
  );
};
